import { useState, useEffect, useCallback } from 'react';
import { apiUrl } from '../../utils/api';

export interface SearchResult {
    type: 'Agent' | 'User' | 'Log';
    id: string;
    title: string;
    subtitle: string;
    link: string;
}

export const useSearch = (delay: number = 300) => {
    const [query, setQuery] = useState('');
    const [results, setResults] = useState<SearchResult[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (!query.trim() || query.length < 2) {
            setResults([]);
            setIsLoading(false);
            return;
        }

        const handler = setTimeout(async () => {
            setIsLoading(true);
            try {
                const response = await fetch(apiUrl(`/api/dashboard/search?q=${encodeURIComponent(query)}`));
                if (response.ok) {
                    const data = await response.json();
                    setResults(data);
                } else {
                    console.error('Search failed');
                    setResults([]);
                }
            } catch (error) {
                console.error('Error during search:', error);
                setResults([]);
            } finally {
                setIsLoading(false);
            }
        }, delay);

        return () => clearTimeout(handler);
    }, [query, delay]);

    const handleSearch = useCallback((q: string) => {
        setQuery(q);
        if (q.trim()) {
            setIsOpen(true);
        } else {
            setIsOpen(false);
        }
    }, []);

    return {
        query,
        setQuery: handleSearch,
        results,
        isLoading,
        isOpen,
        setIsOpen,
    };
};
